import React, { useState, useCallback } from 'react'
import styled from 'styled-components'
import { Heading, Card, CardBody, Button } from '@pancakeswap-libs/uikit'
import { useWallet } from '@binance-chain/bsc-use-wallet'
import BigNumber from 'bignumber.js'
import useI18n from 'hooks/useI18n'
import { useAllHarvest } from 'hooks/useHarvest'
import useFarmsWithBalance from 'hooks/useFarmsWithBalance'
import UnlockButton from 'components/UnlockButton'
import { add2Metamask, addDND2Metamask } from 'utils/add2Metamask'
import CakeHarvestBalance from './CakeHarvestBalance'
import CakeWalletBalance from './CakeWalletBalance'
import { usePriceDND,usePriceBnbBusd } from '../../../state/hooks'
import useTokenBalance from '../../../hooks/useTokenBalance'
import { getDNDAddress } from '../../../utils/addressHelpers'
import useAllEarnings from '../../../hooks/useAllEarnings'
import useAllStaked from '../../../hooks/useAllStaked'
import { getBalanceNumber } from '../../../utils/formatBalance'


const StyledFarmStakingCard = styled(Card)`
  background-image: url('/images/dungeon/dragon_icon2.svg'),url('${process.env.REACT_APP_MEDIA_ROOT}bg/stone1b.jpg');
  background-repeat: no-repeat,repeat;
  background-position: top right;
  background-size: 50%,600px;

  min-height: 376px;
`

const Block = styled.div`
  margin-bottom: 16px;
`

const CardImage = styled.img`
  margin-bottom: 16px;
`

const Label = styled.div`
  color: ${({ theme }) => theme.colors.textSubtle};
  font-size: 14px;
`

const Actions = styled.div`
  margin-top: 24px;
`

const Add2Metamask=styled.div`
display:inline-block;
border-radius:20px;
position:relative;
top:-40px;
margin-left:10px;
color:white;
font-size:20px;
background-color: #7D7C80;
padding:0px 10px 10px 10px;
img{
	width:25px;
	position:relative;
	top:5px;
}
`

const FarmedStakingCard = () => {
  const [pendingTx, setPendingTx] = useState(false)
  const { account,ethereum } = useWallet()
  const TranslateString = useI18n()
  const farmsWithBalance = useFarmsWithBalance()
  const DNDBalance = getBalanceNumber(useTokenBalance(getDNDAddress()))
  const DNDPrice = usePriceDND().toNumber()
  const BNBPrice = usePriceBnbBusd().toNumber()
  const allEarnings = useAllEarnings()
  const earningsSum = allEarnings.reduce((accum, earning) => {
    return accum + new BigNumber(earning).div(new BigNumber(10).pow(18)).toNumber()
  }, 0)
  const balancesWithValue = farmsWithBalance.filter((balanceType) => balanceType.balance.toNumber() > 0)

  const { onReward } = useAllHarvest(balancesWithValue.map((farmWithBalance) => farmWithBalance.pid))


  const allTSV = useAllStaked(BNBPrice,DNDPrice);
  const TSV = allTSV.reduce((accum, earning) => {
    return accum + new BigNumber(earning).div(new BigNumber(10).pow(18)).toNumber()
  }, 0)




  const harvestAllFarms = useCallback(async () => {
    setPendingTx(true)
    try {
      await onReward()
    } catch (error) {
      // TODO: find a way to handle when the user rejects transaction or it fails
    } finally {
      setPendingTx(false)
    }
  }, [onReward])

  return (
    <StyledFarmStakingCard>
      <CardBody>
        <Heading size="xl" mb="24px">
          {TranslateString(542, 'Farms & Staking')}
        </Heading>
        <CardImage src="/images/dungeon/coin_logo.svg" alt="cake logo" width={64} height={64}  onClick={()=>{addDND2Metamask(ethereum)}}/>

		<Add2Metamask onClick={()=>{addDND2Metamask(ethereum)}} >
		+
		<img src="images/dungeon/metamask.png" alt="" />
		</Add2Metamask>
		
		
		

        <Block>
          <Label>{TranslateString(544, 'DND to Harvest')}</Label>
          <CakeHarvestBalance earningsSum={earningsSum}/>
          <Label>~${(DNDPrice * earningsSum).toFixed(2)}</Label>
        </Block>
        <Block>
          <Label>{TranslateString(546, 'DND in Wallet')}</Label>
          <CakeWalletBalance DNDBalance={DNDBalance} />
          <Label>~${(DNDPrice * DNDBalance).toFixed(2)}</Label>
        </Block>
        <Block>
          <Label>{TranslateString(802, 'Total Staked Value:')}</Label>
          <CakeWalletBalance DNDBalance={TSV} DollarSign />
        </Block>

        <Actions>
          {account ? (
            <Button
              id="harvest-all"
              disabled={balancesWithValue.length <= 0 || pendingTx}
              onClick={harvestAllFarms}
              fullWidth
            >
              {
			  	pendingTx
                ? TranslateString(548, 'Collecting DND')
                : TranslateString(999, `Harvest all (${balancesWithValue.length})`)
				// 532
				}
            </Button>
          ) : (
            <UnlockButton fullWidth />
          )}
        </Actions>
      </CardBody>
    </StyledFarmStakingCard>
  )
}

export default FarmedStakingCard
